import { render, staticRenderFns } from "./reservationDoctorList.vue?vue&type=template&id=0a995a02&scoped=true"
import script from "./reservationDoctorList.vue?vue&type=script&lang=js"
export * from "./reservationDoctorList.vue?vue&type=script&lang=js"
import style0 from "./reservationDoctorList.vue?vue&type=style&index=0&id=0a995a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a995a02",
  null
  
)

export default component.exports